var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lq-remarks-wrap",class:{
		'lq-remarks-wrap--empty': !_vm.displayText,
		'lq-remarks-wrap--short': _vm.displayText && _vm.isShort
	}},[(_vm.displayText)?[_c('el-tooltip',{attrs:{"disabled":!_vm.overflow,"content":_vm.displayText,"placement":"top-start","open-delay":2000,"popper-class":"lq-remarks-tooltip"}},[_c('div',{ref:"textEl",staticClass:"lq-remarks-text"},[_vm._v(_vm._s(_vm.displayText))])])]:_c('div',{staticClass:"lq-remarks-text lq-remarks-text--empty"},[_vm._v(_vm._s(_vm.emptyText))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }